import React from 'react'
import { Redirect } from 'react-router-dom'
import Footer from 'components/layout/Footer/index'
import AppInitializer from 'components/layout/AppInitializer/index'

const PrivateRoute = ({ Component, isAuthenticated, child, isHeader, isFooter }) => {
  return isAuthenticated
    ? (
      <>
        {isHeader ? <AppInitializer /> : <></>}
        <div className='flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden'>
          <Component child={child} />
        </div>
        {isFooter ? <Footer /> : <></>}
      </>
      )
    : (
      <Redirect to={{ pathname: '/' }} />
      )
}

export default PrivateRoute
